'use client';

import * as React from 'react';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { CaretDown } from 'phosphor-react';
import { useI18n } from '@/app/providers';
import { locales, type Locale } from '@/lib/i18n';
import { GlobeIcon } from '@/components/icons/globe';
import { cn } from '@/lib/utils';

const localeLabels: Record<Locale, string> = {
  it: 'Italiano',
  en: 'English',
};

export function LanguageSwitcher() {
  const { locale, setLocale, isLoading } = useI18n();
  const [open, setOpen] = React.useState(false);

  return (
    <DropdownMenuPrimitive.Root open={open} onOpenChange={setOpen}>
      <DropdownMenuPrimitive.Trigger
        suppressHydrationWarning
        disabled={isLoading}
        className={cn(
          'flex items-center gap-2 px-4 py-2 rounded-lg',
          //'bg-white/10 hover:bg-white/15',
          'text-white text-sm font-medium',
          'transition-all outline-none',
          'focus-visible:ring-2 focus-visible:ring-white/50',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          'data-[state=open]:bg-white/15'
        )}
      >
        <GlobeIcon width={20} height={20} />
        <span>{localeLabels[locale]}</span>
        <CaretDown
          className={cn(
            'h-4 w-4 transition-transform duration-200',
            open && 'rotate-180'
          )}
        />
      </DropdownMenuPrimitive.Trigger>

      <DropdownMenuPrimitive.Portal>
        <DropdownMenuPrimitive.Content
          align="end"
          className={cn(
            'min-w-[180px] rounded-lg',
            'bg-white/10 backdrop-blur-sm',
            'border border-white/20',
            'p-1 shadow-lg',
            'z-50',
            'will-change-[opacity,transform]',
            'data-[state=open]:animate-[fadeIn_0.2s_ease-out,slideDown_0.2s_ease-out]',
            'data-[state=closed]:animate-[fadeOut_0.15s_ease-in]'
          )}
          style={{
            animationFillMode: 'forwards',
          }}
        >
          {locales.map((loc) => (
            <DropdownMenuPrimitive.Item
              key={loc}
              onClick={() => {
                setLocale(loc);
                setOpen(false);
              }}
              className={cn(
                'flex items-center gap-2 px-3 py-2 rounded-md text-sm',
                'text-white cursor-pointer outline-none',
                'transition-colors',
                'hover:bg-white/15 focus:bg-white/15',
                locale === loc && 'bg-white/10 font-medium'
              )}
            >
              <span>{localeLabels[loc]}</span>
            </DropdownMenuPrimitive.Item>
          ))}
        </DropdownMenuPrimitive.Content>
      </DropdownMenuPrimitive.Portal>
    </DropdownMenuPrimitive.Root>
  );
}
